function SvgClose({ className }) {
  return (
    <svg
      className={`${className}`}
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.705 11.4677C13.0563 11.8182 13.0563 12.3867 12.705 12.7372C12.3536 13.0876 11.7835 13.0876 11.4321 12.7372L7.00061 8.28477L2.53765 12.7357C2.18628 13.0861 1.61618 13.0861 1.26477 12.7357C0.913357 12.3852 0.913394 11.8167 1.26477 11.4662L5.72923 7.01683L1.26353 2.53227C0.912157 2.18185 0.912157 1.61329 1.26353 1.26283C1.6149 0.912371 2.185 0.912408 2.53641 1.26283L7.00061 5.74889L11.4636 1.29799C11.8149 0.947566 12.385 0.947566 12.7365 1.29799C13.0879 1.64841 13.0878 2.21697 12.7365 2.56743L8.27199 7.01683L12.705 11.4677Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgClose;
